import { persistentAtom } from "@nanostores/persistent";

// TODO: rename to isExpanded
export const railExpandedStore = persistentAtom<boolean>("railExpanded", true, {
	encode: (boolean) => (boolean ? "true" : "false"),
	decode: (string) => (string === "true" ? true : false),
});

export const toggleRail = () => {
	railExpandedStore.set(!railExpandedStore.get());
	let wrapper = document.getElementById("opteraLayout-wrapper");
	wrapper.classList.toggle("nav-wide");
};
